import { render, staticRenderFns } from "./InsuficienteBalance.vue?vue&type=template&id=1c52559f&scoped=true&"
import script from "./InsuficienteBalance.vue?vue&type=script&lang=js&"
export * from "./InsuficienteBalance.vue?vue&type=script&lang=js&"
import style0 from "./InsuficienteBalance.vue?vue&type=style&index=0&id=1c52559f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c52559f",
  null
  
)

export default component.exports